import { Users } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface PeopleEmptyStateProps {
  onInvite?: () => void;
}

export function PeopleEmptyState({ onInvite }: PeopleEmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <div className="rounded-full bg-primary/10 p-4 mb-4">
        <Users className="h-8 w-8 text-primary" />
      </div>
      <h3 className="text-lg font-semibold mb-1">Build your campaign team</h3>
      <p className="text-muted-foreground text-sm max-w-sm mb-4">
        Invite volunteers and staff members to join your campaign.
      </p>
      {onInvite && (
        <Button onClick={onInvite}>
          Invite Member
        </Button>
      )}
    </div>
  );
}
